import React from 'react';
import {Messages} from 'commons/constants';

export const useAlert = () => {
    const [actions, setActions] = React.useState<Array<string>>();
    const [reactElement, setReactElement] = React.useState<JSX.Element>();
    const [showAlert, setShowAlert] = React.useState<boolean>(false);
    const [genericError, setGenericError] = React.useState<any>({});
    const [defaultError, setDefaultError] = React.useState<string>(Messages.GENERIC_ALERT_ERROR);

    function closeAlert() {
        setShowAlert(false);
        setActions(undefined);
        setReactElement(undefined);
    }

    function showAlertError(error: any, defaultMsg: string) {
        setGenericError(error);
        setDefaultError(defaultMsg);
        setShowAlert(true);
    }

    function showCustomAlert(
        defaultMessage: string,
        actions?: Array<string>,
        reactElement?: JSX.Element
    ) {
        setActions(actions);
        setReactElement(reactElement);
        setDefaultError(defaultMessage);
        setShowAlert(true);
    }
    return {
        actions,
        showAlert,
        closeAlert,
        genericError,
        defaultError,
        reactElement,
        showAlertError,
        showCustomAlert,
    };
};
